import { render, staticRenderFns } from "./centerRight1.vue?vue&type=template&id=178870b2&scoped=true&"
import script from "./centerRight1.vue?vue&type=script&lang=js&"
export * from "./centerRight1.vue?vue&type=script&lang=js&"
import style0 from "./centerRight1.vue?vue&type=style&index=0&id=178870b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178870b2",
  null
  
)

export default component.exports